exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logoRetse{\n  width:150px;\n}\n.Masthead {\n  z-index: 0!important;\n}\n.fondoInicio {\n  height:100vh;\n}\n.secciones a, .secciones a:hover {\n  color: inherit;\n  text-decoration: inherit;\n}\n.text-center.secciones {\n  position: absolute;\n  top:5%;\n}\n@media screen and (max-width: 600px) {\n.Masthead__image.is-parallax > img {\n}\n.fondoInicio {\n    height: 70vh!important;\n    margin:0px;\n}\n.text-center.secciones {\n  position: absolute;\n  top:4%;\n}\n.logoRetse{\n  width:100px;\n}\n}\n\n", ""]);

// exports
